import type { AnyGameModule, Discipline } from './core/contracts'
import { memoryMatrix } from './games/memory-matrix'
import { missingOne } from './games/missing-one'
import { reactionTarget } from './games/reaction-target'
import { snowflake } from './games/snowflake'
import { stroop } from './games/stroop'

/**
 * Единственный список игр в приложении.
 *
 * Добавить игру = импортировать модуль и дописать в GAMES.
 * Больше нигде в коде правок не требуется - ни в ядре, ни в экранах.
 */
export const GAMES: readonly AnyGameModule[] = [
  memoryMatrix,
  missingOne,
  stroop,
  reactionTarget,
  snowflake,
]

export function gameById(id: string): AnyGameModule | undefined {
  return GAMES.find((g) => g.id === id)
}

export function gamesOf(discipline: Discipline): AnyGameModule[] {
  return GAMES.filter((g) => g.discipline === discipline)
}
